import React from 'react';
import { Outlet } from 'react-router-dom';
import { withAuthenticationRequired } from '@auth0/auth0-react';

const AuthenticatedLayoutInner: React.FC = () => {
  return <Outlet />;
};

export const AuthenticatedLayout = withAuthenticationRequired(AuthenticatedLayoutInner, {});
